import api from 'Application/api/api';

const getEntityById = async (signal, id, details = true) => {
	const response = await api.get(`/contract-parties/${id}`, {
		params: {
			details,
		},
		signal,
	});

	if (!response || !response.data) {
		return response;
	}

	return response;
};

export default getEntityById;
